import { useQuery } from '@tanstack/react-query';
import { mapProposalEntityToTemplateData } from '@modules/proposals/presentation/v2/pages/ProposalCreation/views/Configurator/mappers/mapProposalEntityToTemplateData';
import useFeatureFlags from '@modules/core/hooks/useFeatureFlags';
import { proposalApi } from '@modules/proposals/api';

const useGetProposalPreviewById = (proposalId?: string, refetchInterval?: number) => {
  const { isFeatureActive, isFeatureFlagsLoading } = useFeatureFlags();
  const {
    data, isLoading, error, refetch, isFetched,
  } = useQuery({
    ...(refetchInterval ? { refetchInterval } : {}),
    queryKey: ['proposalPreview', proposalId],
    queryFn: () => proposalApi.getProposalPreviewByExternalId(proposalId!),
    staleTime: 300000,
    select: mapProposalEntityToTemplateData,
    // eslint-disable-next-line max-len
    enabled: !!proposalId && !isFeatureFlagsLoading && isFeatureActive('proposals.module') && !isFeatureActive('proposals.baytecaMVP'),
  });

  return {
    data,
    isLoading,
    error,
    refetch,
    isFetched,
  };
};

export default useGetProposalPreviewById;
